<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">{{'UNSAVED_CHANGES_TITLE' | translate}}</label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition"
        mat-dialog-close="cancel"></button>
</div>
<mat-dialog-content>{{'UNSAVED_CHANGES_MESSAGE' | translate}}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="openCloseBtn" mat-raised-button color="primary" mat-dialog-close="save">{{'SAVE' |
        translate}}</button>
    <button class="openCloseBtn" mat-raised-button color="primary" mat-dialog-close="discard">{{'DISCARD_CHANGES' |
        translate}}</button>
    <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close="cancel">{{'CANCEL' |
        translate}}</button>
</mat-dialog-actions>